import * as React from 'react';
import * as _ from 'lodash'
import {
    ToolTipIcon,
    QuestionMark,
    IconContainer,
    ToolTipBody,
    ToolTipBox,
    ToolTipContainer,
    ToolTipTextContainer,
    ToolTipTitle
} from './styles';
import { SIZE } from 'common/sizes';

export enum ToolTipDirection {
    BOTTOM_LEFT = "BOTTOM_LEFT",
    BOTTOM_RIGHT = "BOTTOM_RIGHT"
}

export interface ToolTipProps {
    icon?: string
    title?: string
    key?: string
    description?: string
    position?: ToolTipDirection
    background?:string

    renderIcon?: () => any;
    renderBody?: () => any;
}

const ToolTip = (props: ToolTipProps) => {
    const key = props.key ?? "toolTip";
    const { top, left } = calculatePosition(props.position);

    const HoverableElement = props.icon ? ToolTipIcon : props.renderIcon ? IconContainer : QuestionMark;

    return (
        <ToolTipContainer key={`tt-container-${key}`}>
            <HoverableElement
                {...{ left, top, iconCode: props.icon }}
                key={`tt-${key}`}
            >
                {
                    props.renderIcon ?
                        props.renderIcon()
                        :
                        !props.icon && "?"
                }
                <ToolTipBox key={`tt-box-${key}`} style={{backgroundColor:props.background?props.background:'#ffffff'}}>
                    <ToolTipTextContainer>
                        {
                            props.title &&
                            <ToolTipTitle>
                                {
                                    props.title
                                }
                            </ToolTipTitle>
                        }
                        <ToolTipBody>
                            {
                                props.description && props.description
                            }
                            {
                                props.renderBody && props.renderBody()
                            }
                        </ToolTipBody>
                    </ToolTipTextContainer>
                </ToolTipBox>
            </HoverableElement>
        </ToolTipContainer>
    )

    function calculatePosition(position = ToolTipDirection.BOTTOM_RIGHT) {
        switch (position) {
            case ToolTipDirection.BOTTOM_LEFT: {
                return {
                    top: `${SIZE.THREE}px`,
                    left: `-95%`
                }
            }
            case ToolTipDirection.BOTTOM_RIGHT: {
                return {
                    top: `${SIZE.HALF}px`,
                    left: `${SIZE.THREE}px`
                }
            }
        }
    }
}

export default ToolTip;